<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog v-if="userIdDialog" v-model="userIdDialog" :max-width="size === 'sm' ? 295 : 364" max-height="90vh" :retain-focus="false" persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header pa-0 text-center">
						<h4 class="fs--24 fw--600 popup-header-text pt-9">Click to Enable!</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content">
							<v-img src="@/assets/images/logo.png" contain height="100%"></v-img>

							<div class="d-flex">
								<div class="text-center">
									<h4 class="fs--12 fw--600 popup-footer-text">
										Authorize this extension to slap stickers on the live stream!
									</h4>
								</div>
							</div>

							<v-btn
								block
								color="primary"
								class="fs--15 fw--600 mt-4 action-btn text-uppercase"
								@click="promptForPermission">
								ENABLE
							</v-btn>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { computed } from 'vue';
import { mdiClose } from '@mdi/js';

export default {
	props: {
		userIdDialog: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['onClose'],
	setup(_, ctx) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);
		const streamerDisplayName = computed(() => store.state.streamerDisplayName);

		const close = () => {
			ctx.emit('onClose');
		};

		const promptForPermission = () => {
			window.Twitch.ext.actions.requestIdShare(function () {
				console.log('request id share called.');
			});
			//ctx.emit('onClose');
		};

		const cancelEvent = event => {
			event.stopImmediatePropagation();
		};

		return {
			theme,
			size,
			close,
			cancelEvent,
			streamerDisplayName,
			promptForPermission,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>
